export const SENT_MAIL = "SENT_MAIL";
export const SENT_SET_FALSE = "SENT_SET_FALSE";
export const SET_LOADING = "SET_LOADING";
